<template>
    <transition name="fade">
        <div v-show="false" class="topAdsWrap">
            <div class="closeBox">
                <i class="iconfont icon-quxiao" @click="closeTopAds"></i>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'TopAds',// 顶部广告图
        data() {
            return {
                isShow: this.$getCookie('topAdsCd') !== '1',// 获取当前显示状态
            };
        },
        methods: {
            closeTopAds() {
                this.isShow = false;
                this.$setCookie('topAdsCd', '1', 0.5);
            }
        }
    };
</script>

<style lang="scss" scoped>

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .topAdsWrap {
        position: relative;
        width: 100%;
        min-width: 1245px;
        height: 100px;
        background-image: url('~@/assets/img/general/topAdsImg.png');
        background-position: center;

        .closeBox {
            position: relative;
            width: 1245px;
            height: 100%;
            margin: 0 auto;

            .iconfont {
                position: absolute;
                top: 5px;
                right: 5px;
                font-size: 18px;
                color: #2d2d2d;
                cursor: pointer;
                opacity: 0.3;
            }
        }
    }
</style>
